// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { Secret } from '@models/secretos.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SecretosService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getSecretos(names?: string[]): Observable<Secret[]> {
    let params: HttpParams = new HttpParams();
    if (names) {
      let formattedNames: string = '';
      for (let i = 0; i < names.length; i++) {
        if (i === 0) {
          formattedNames = `${names[i]}`;
        } else {
          formattedNames = `${formattedNames}|${names[i]}`;
        }
      }
      params = params.set('nombres', formattedNames);
    }

    return this.http.get<Secret[]>(`${this.globalService.apiUrl.url}/Secretos`, { ...this.httpOptions, params });
  }

  postCreateSecreto(secret: Secret): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Secretos`, secret, this.httpOptions);
  }

  getSecreto(name: string): Observable<Secret> {
    return this.http.get<Secret>(`${this.globalService.apiUrl.url}/Secretos/${name}`, this.httpOptions);
  }

  putEditSecreto(name: string, secret: Secret): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/Secretos/${name}`, secret, this.httpOptions);
  }

  deleteSecreto(name: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Secretos/${name}`, this.httpOptions);
  }
}